export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validatePhone = (phone) => {
  const re = /^[6-9]\d{9}$/;
  return re.test(String(phone).trim());
};

export const validatePassword = (password) => {
  return password.trim() !== "";
};

export const validatePasswordChar = (password) => {
  return password.length >= 8;
};

export const validateOTP = (otp) => {
  return String(otp || "").length === 5;
};

export const validateRequired = (value) => {
  return (value || "") !== "";
};
export const validatePincode = (pincode) => {
  const re = /^\d{6}$/;
  return re.test(String(pincode));
};
